<template>
  <div class="index-cooperate">
    <div class="w1200 animate_top in index-cooperate-box" style="display: block">
      <h2>{{ element.titleBarName }}</h2>
      <template v-if="childItem.propsValue.data.length > 1">
        <div class="index-use-tab">
          <div
            :class="'index-use-tab-item' + (index == 0 ? ' active' : '')"
            v-for="(item, index) in childItem.propsValue.data"
            :key="index"
          >
            {{ item.customField1 }}
            <div v-if="index == 0" class="index-use-line"></div>
          </div>
        </div>

        <div class="index-line"></div>
      </template>
      <div class="index-cooperate-flex">
        <div
          class="index-cooperate-item"
          v-for="(item, index) in childItem.propsValue.data[0].customField2"
          :key="index"
        >
          <img :src="item.customField4" alt />
          <h3>{{ item.customField5 }}</h3>
          <p>{{ item.customField6 }}</p>
          <span class="index-cooperate-item-luokuan">{{ item.customField7 }}</span>
          <span v-if="item.customField9 && item.customField9.text">{{ item.customField9.text }}</span>
        </div>
      </div>
      <ul class="index-cooperate-list">
        <li v-for="(item, index) in childItem.propsValue.data[0].customField3" :key="index">
          <img :src="item.customField8" alt />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { buttonObject } from "../../../../../config/elementObject.js";

let buttonAnliInfo = _.cloneDeep(buttonObject);
buttonAnliInfo.text = "查看详情";

export default {
  name: "MkKehuanliWeb",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "组名",
          type: "text"
        },
        {
          code: "customField2",
          label: "案例\r\n信息",
          type: "list",
          children: [
            {
              code: "customField4",
              label: "logo",
              type: "image",
              width: 330,
              height: 60
            },
            {
              code: "customField5",
              label: "标题",
              type: "text"
            },
            {
              code: "customField6",
              label: "描述",
              type: "text"
            },
            {
              code: "customField7",
              label: "落款",
              type: "text"
            },
            {
              code: "customField9",
              label: "按钮",
              type: "button"
            }
          ]
        },
        {
          code: "customField3",
          label: "客户墙",
          type: "list",
          children: [
            {
              code: "customField8",
              label: "logo",
              type: "image",
              width: 220,
              height: 80
            }
          ]
        }
      ],
      data: [
        {
          customField1: "分组名称1",
          customField2: [
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU986AXTW7AAAySaQCLGE206.png",
              customField5: "案例标题1",
              customField6: "案例内容描述信息...",
              customField7: "",
              customField9: _.cloneDeep(buttonAnliInfo)
            },
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU9_qAbyvbAAApmyXaz7U199.png",
              customField5: "案例标题2",
              customField6: "案例内容描述信息...",
              customField7: "",
              customField9: _.cloneDeep(buttonAnliInfo)
            },
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/08/7D/CgoRC2LU99yARVQLAAAsJoqjIUQ389.png",
              customField5: "案例标题3",
              customField6: "案例内容描述信息...",
              customField7: "",
              customField9: _.cloneDeep(buttonAnliInfo)
            }
          ],
          customField3: []
        }
      ]
    };
  }
};
</script>


<style lang="scss" scoped>
.index-cooperate {
  width: 100%;
  height: 100%;
  padding: 30px 0;

  .index-use-tab {
    padding-bottom: 18px;
    display: flex;
    justify-content: space-between;

    .index-use-tab-item {
      flex: 1;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      line-height: 23px;
      letter-spacing: 1px;
      color: #707070;
      cursor: pointer;
    }

    .index-use-tab-item.active,
    .index-use-tab-item:hover {
      color: #e31824;
    }
  }

  .index-use-line {
    width: 75px;
    height: 4px;
    background-color: #e31924;
    margin: 10px auto 0;
  }

  .index-line {
    width: 1200px;
    height: 1px;
    background-color: #000000;
    opacity: 0.1;
    margin-top: 4px;
  }
}

.index-cooperate-box {
  height: 100%;

  h2 {
    font-weight: bold;
    font-size: 30px;
    line-height: 26px;
    letter-spacing: 2px;
    color: #e31924;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
    margin: 0 auto;
  }

  .index-cooperate-flex {
    display: flex;
    width: 100%;
    height: 250px;

    .index-cooperate-item {
      flex: 1;
      padding: 8px 15px 0;
      max-width: 300px;
      img {
        width: 280px;
        border: 0;
        -ms-interpolation-mode: bicubic;
      }

      h3 {
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        color: #333333;
        margin-bottom: 20px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-top: 0;
      }

      p {
        width: 100%;
        height: 120px;
        font-size: 13px;
        line-height: 20px;
        color: #6f6f6f;
        margin: 0 auto;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        line-clamp: 6;
      }

      &-luokuan {
        display: block;
        height: 20px;
        line-height: 20px;
      }
      &-button {
        display: block;
        height: 20px;
        line-height: 20px;
      }
    }
  }

  .index-cooperate-list {
    overflow: hidden;
    margin: 42px 0 0 0px;
    padding-left: 0;

    li {
      float: left;
      width: 190px;
      height: 50px;
      line-height: 50px;
      background-image: linear-gradient(#ffffff, #ffffff),
        linear-gradient(#e50b18, #e50b18);
      background-blend-mode: normal, normal;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.3s ease-in;
      margin-left: 25px;
      margin-top: 16px;
      list-style: none;
      text-align: center;

      img {
        max-width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
